import { render, staticRenderFns } from "./FootballBasicMatchStatsWidget.vue?vue&type=template&id=444ac5ae&scoped=true"
import script from "./FootballBasicMatchStatsWidget.vue?vue&type=script&lang=js"
export * from "./FootballBasicMatchStatsWidget.vue?vue&type=script&lang=js"
import style0 from "./FootballBasicMatchStatsWidget.vue?vue&type=style&index=0&id=444ac5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ac5ae",
  null
  
)

export default component.exports